/* src/app/form-languages/components/language-switch/language-switch.component.css */
@layer properties;
.lang-list {
  display: flex;
  list-style-type: none;
  align-items: center;
  padding-inline-start: calc(var(--spacing, 0.25rem) * 0);
}
.lang-item {
  margin-inline-end: calc(var(--spacing, 0.25rem) * 1);
  cursor: pointer;
}
.lang-item.active {
  cursor: auto;
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
  color: var(--color-primary-500, #257948);
}
@property --tw-font-weight { syntax: "*"; inherits: false; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-font-weight: initial;
    }
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=language-switch.component.css.map */
